<template>
  <div>
    <v-container class="pt-0 pb-5">
        <v-layout wrap>
          <v-flex xs12 class="ma-2">
            <div class="text-sm-left f-20" color="#002d4a">Package View (Package name)</div>
          </v-flex>
          <v-divider></v-divider>
        </v-layout>
      <!--<h1 class="ml-4">Classes</h1>-->
      <v-card class="grey lighten-3 no-shadow card-r mt-2">
        <v-btn icon to="/packages">
          <v-icon color="grey">keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn icon flat color="grey" to="/confirmdelete" class="text-xs-right right"><v-icon>delete</v-icon></v-btn>
        <v-btn icon flat color="grey" to="/EditPackage" class="text-xs-right right"><v-icon class="px-2">edit</v-icon></v-btn>
      </v-card>

      <v-layout xs12 class="mt-2 card-r">
        <v-flex xs5 offset-xs0 class="text-xs-right right mr-1">
            <v-img height="300"
              src="https://irp-cdn.multiscreensite.com/f6d3566d/dms3rep/multi/mobile/iStock-540862480-2121x1414.jpg"
            ></v-img>
        </v-flex>
        <v-flex xs7 offset-xs0 class="ml-1 grey lighten-3 card-r no-shodow">
          <v-flex xs12 offset-xs0 class="ml-3 mr-3">
            <h1 class="mt-2">12 Classes Of This Package</h1>
          </v-flex>
          <v-layout xs12>
            <v-flex xs12 offset-xs0 class="ml-3 mr-3">
              <span class="f-15 font-weight-bold text--darken-1 ">Price : - </span>
              <span class="f-15 font-weight-bold text--darken-1 ">$ 4500</span>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs12 offset-xs0 class="text-xs-left ml-3">
              <span class="f-15 font-weight-bold text--darken-1">Hours : - </span>
              <span class="f-15 font-weight-bold text--darken-1">xxxxx h</span>
            </v-flex>
          </v-layout>
          <v-layout xs12 class="ml-3 mr-3 mt-2">
            <v-flex xs12 >
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita
                quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo
                fuga ab at.</p>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita
                quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo
                fuga ab at.</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card class="grey lighten-3 no-shadow card-r mt-2">
        <div class="f-20 font-weight-bold ml-2 pa-2">12 Classes Here Of This Package</div>

        <v-container fluid grid-list-xl class="pt-0">
          <v-layout row wrap class="">
          <v-flex d-flex lg3 sm6 xs12  v-for="(n, index) in 12">
            <v-card class="no-shadow card-r">
              <router-link to="/viewclass" class="no-deraction">
                <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                       height="150px"
                       class="card-r">
                  <div class="text-xs-right w-100">
                    <v-btn small class="white" icon to="editclass/"><v-icon class="f-20">edit</v-icon></v-btn>
                    <v-btn small class="white" icon to="editclass/"><v-icon class="f-20">delete</v-icon></v-btn>
                  </div>
                </v-img>
              </router-link>

              <v-card-title primary-title>
                <div class="text-xs-left">
                  <div class="f-14" style="color: #424242;">Class title</div>
                  <div style="color: #424242;">
                    <span class="f-12 font-weight-bold text--darken-1">Mins : - </span>
                    <span class="f-12 font-weight-bold text--darken-1">60 mins</span>
                  </div>
                  <div style="color: #424242;">
                  </div>
                  <v-chip color="primary" class="w-35p" text-color="white">cewferfedwscefcewer</v-chip>
                  <v-chip color="primary" class="w-35p" text-color="white">cewferfedwscefcewer</v-chip>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
        </v-container>
        <!--<v-layout xs12 class="grey lighten-3 no-shadow card-r">-->
          <!--<v-flex xs12 offset-xs0 class="mt-0 mr-2 mb-3">-->
            <!--<v-btn color="primary" class="view-button right card-r no-shadow">-->
              <!--Select Pack-->
            <!--</v-btn>-->
          <!--</v-flex>-->
        <!--</v-layout>-->
      </v-card>

      <!--<v-layout xs12 class="grey lighten-3 no-shadow card-r mt-2 pa-2">-->
        <!--<v-flex xs12 offset-xs0 class=" ">-->
          <!--<v-btn color="primary" class="view-button right card-r no-shadow">-->
            <!--Select Pack-->
          <!--</v-btn>-->
        <!--</v-flex>-->
      <!--</v-layout>-->

    </v-container>
  </div>
</template>
<style>
.v-carousel__next .v-btn i, .v-carousel__prev .v-btn i{
  font-size: 20px !important;
}
.v-carousel__controls{
  display: none!important;
}
</style>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/package/ViewPackage.vue